<script>
	import {documentos,cuenta} from "../controladores/store.js";
	import {beforeUpdate,onMount} from "svelte";
	import {push} from "svelte-spa-router";
	export let params;
	let cliente = {};
	let mascotas = [];
	onMount(()=>{
		cliente = $documentos.filter((el)=> el._id == `cliente:${params.documento}`)[0];
	})
	beforeUpdate(()=>{
		mascotas = $documentos.filter((el)=>{
			return (el.tipo == "mascota" && el.dueno == cliente.documento);
		})
	})
	function agregar(){
		push(`/agregar/mascota/${cliente.documento}`);
	}
	function irMascota(mascota){
		push(`/mascota/${mascota}`);
	}
	function wsp(){
		window.open(`https://wa.me/${cliente.telefono}?text=Hola, `);
	}
	function mail(){
		window.open(`mailto:${cliente.email}`);
	}
</script>
<div class="w-screen h-full max-w-full min-h-screen flex flex-col items-center justify-start bg-purple-300">
	<a href="#/home" class="self-start flex items-center justify-center p-2 m-4 bg-purple-500 text-white rounded">Volver</a>
	<div class="flex flex-col items-center justify-start bg-gray-100 rounded m-4 p-4 w-3/4 h-auto shadow">
		<h1 class="text-xl font-bold mx-auto">{cliente.nombre}</h1>
		<div class="w-3/4 flex items-center flex-col sm:flex-row  justify-between my-4">
			<div class="flex flex-col items-start cursor-pointer" on:click={wsp}>
				<span class="flex items-center text-sm font-bold"><i class="ri-phone-line mx-2"/>Telefono</span>
				{cliente.telefono}
			</div>
			<div class="flex flex-col items-start cursor-pointer" on:click={mail}>
				<span class="flex items-center text-sm font-bold"><i class="ri-mail-line mx-2"/>Email</span>
				{cliente.email}
			</div>
		</div>
	<div class="w-3/4 flex items-center flex-col sm:flex-row justify-between my-4">
			<div class="flex flex-col items-start">
				<span class="flex items-center text-sm font-bold"><i class="ri-account-box-line mx-2"/>Documento</span>
				{cliente.documento}
			</div>
			<div class="flex flex-col items-start">
				<span class="flex items-center text-sm font-bold"><i class="ri-map-pin-line mx-2"/>Dirección</span>
				{cliente.direccion}
			</div>
		</div>
	</div>
	<div class="flex flex-col items-center justify-start bg-gray-100 rounded m-4 p-4 w-3/4 h-auto shadow">
		<h1 class="text-xl font-bold mx-auto" >Mascotas</h1>
		<div class="flex items-center justify-start divide-x-2 divide-pink-300">
			{#each mascotas as mascota}
				<div on:click={()=>{irMascota(mascota.documento)}} class="flex flex-col items-center justify-center p-4 cursor-pointer hover:bg-pink-300">
					<i class="text-xl ri-bear-smile-line"/>
					{mascota.nombre}
				</div>
			{/each}
			<div on:click={agregar} class="flex flex-col items-center justify-center p-4 cursor-pointer hover:bg-pink-300">
				<i class="text-xl ri-add-line"/>
				Agregar Mascota
			</div>
		</div>
	</div>
</div>
